module.exports = __webpack_public_path__ + "static/media/crosshairs.4c18f017.svg";